import { styled, Text } from '@volkswagen-onehub/components-core';
import React from 'react';
import { getLang, getTranslations } from '../translations';
import { formatDistance } from '../utils/format';
import { replaceStringWithJSX } from '../utils/replace-string-with-jsx';
import UserLocation from '../UserLocation';
import { FindCar } from '@volkswagen-onehub/icons-core';
import { useAppliedFilterStore } from '../store/filtersv2';

const Container = styled.div`
  margin: 0;
  padding: ${props => props.theme.size.dynamic0100} ${props => props.theme.size.grid002};
  display: flex;
  column-gap: 16px;
`;

const NoWrapText = styled(Text)`
  white-space: nowrap;
`;

export const PageSummary = () => {
  const lang = getLang();
  const { labels } = getTranslations();
  const { applied } = useAppliedFilterStore();
  const { distance } = applied;

  const changes = {
    distance: (
      <NoWrapText bold>
        { formatDistance(distance as number, lang) }
      </NoWrapText>
    ),
    postalCode: <UserLocation inline/>
   };

  return (
    <Container>
      <FindCar variant="default" ariaHidden />
      <Text>
        { replaceStringWithJSX(labels.view_summary_msp, changes)}
      </Text>
    </Container>
  );
};
